import { render, staticRenderFns } from "./Formation.vue?vue&type=template&id=c7cb9bba&scoped=true"
import script from "./Formation.vue?vue&type=script&lang=js"
export * from "./Formation.vue?vue&type=script&lang=js"
import style0 from "./Formation.vue?vue&type=style&index=0&id=c7cb9bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cb9bba",
  null
  
)

export default component.exports